"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _axios = _interopRequireDefault(require("axios"));

var _reactToastify = require("react-toastify");

var _formik = require("formik");

var _ = require("../");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _moment = _interopRequireDefault(require("moment"));

var _schema = require("./schema");

var _defaultTranslations = require("./defaultTranslations");

var _reactDeviceDetect = require("react-device-detect");

var _SignupStep = _interopRequireDefault(require("./SignupStep1"));

var _SignupStep2 = _interopRequireDefault(require("./SignupStep2"));

var _SignupStep3 = _interopRequireDefault(require("./SignupStep3"));

var _SignupStep4 = _interopRequireDefault(require("./SignupStep4"));

var _ConfirmStep = _interopRequireDefault(require("./ConfirmStep"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var Signup = function Signup(_ref) {
  var translations = _ref.translations,
      onSuccess = _ref.onSuccess,
      onError = _ref.onError,
      onPageButtonClicked = _ref.onPageButtonClicked,
      termsSlug = _ref.termsSlug,
      useAssetsCdn = _ref.useAssetsCdn,
      privacySlug = _ref.privacySlug,
      colorPrimary = _ref.colorPrimary;

  if (!translations) {
    translations = _defaultTranslations.defaultTranslations;
  }

  var showFallbackDatePicker = _reactDeviceDetect.isSafari && !_reactDeviceDetect.isMobileSafari || _reactDeviceDetect.isIE || _reactDeviceDetect.isAndroid;

  var _useState = (0, _react.useState)({
    activeStep: 0,
    signupError: undefined,
    location: "",
    dialingCode: "",
    isNonUk: undefined
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = (0, _react.useState)({
    firstName: "",
    lastName: "",
    birthDate: "",
    mobileNumber: "",
    mobileNumberConfirm: "",
    username: "",
    inAppNotificationsAccepted: false,
    smsNotificationsAccepted: false,
    emailNotificationsAccepted: false,
    agreedTerms: false,
    agreedPrivacy: false,
    checkAll: false,
    enterAddressManually: false,
    postcode: "",
    street1: "",
    street2: "",
    city: "",
    county: "",
    pin: "",
    pinConfirm: "",
    password: "",
    passwordConfirm: ""
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      initialValues = _useState4[0],
      setInitialValues = _useState4[1]; // if (process.env.NODE_ENV === "development") {
  //   initialValues.firstName = "test";
  //   initialValues.lastName = "Test";
  //   initialValues.username = "test3983838";
  //   initialValues.email = "test@test.com";
  //   initialValues.emailConfirm = "test@test.com";
  //   initialValues.mobileNumber = "+440777777777";
  //   initialValues.mobileNumberConfirm = "+440777777777";
  //   initialValues.postcode = "B262NJ";
  //   initialValues.city = "Solihull";
  //   initialValues.street1 = "14 Benedon Road";
  //   initialValues.birthDate = "1975-01-01";
  //   initialValues.pin = "1111";
  //   initialValues.pinConfirm = "1111";
  //   initialValues.password = "Password1";
  //   initialValues.passwordConfirm = "Password1";
  // }


  (0, _react.useEffect)(function () {
    setInitialValues(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        mobileNumber: "+" + state.dialingCode,
        mobileNumberConfirm: "+" + state.dialingCode
      });
    });
  }, [state.dialingCode]);

  var onLocationSuccess = function onLocationSuccess(_ref2) {
    var country = _ref2.country,
        dialingCode = _ref2.dialingCode,
        isNonUk = _ref2.isNonUk;
    setState(_objectSpread(_objectSpread({}, state), {}, {
      location: country,
      dialingCode: dialingCode,
      isNonUk: isNonUk
    }));
  };

  (0, _.useIpLocation)(onError, onLocationSuccess);
  var activeStep = state.activeStep,
      location = state.location,
      signupError = state.signupError,
      dialingCode = state.dialingCode,
      isNonUk = state.isNonUk;

  var setActiveStep = function setActiveStep(activeStep) {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      activeStep: activeStep
    }));
  };

  var onSubmit = function onSubmit(values, _ref3) {
    var setSubmitting = _ref3.setSubmitting;
    var showFallbackDatePicker = _reactDeviceDetect.isSafari && !_reactDeviceDetect.isMobileSafari || _reactDeviceDetect.isIE || _reactDeviceDetect.isAndroid;
    var params = {
      location: location,
      firstName: values.firstName,
      lastName: values.lastName,
      username: values.username,
      email: values.email,
      mobileNumber: values.mobileNumber,
      password: values.password,
      pin: values.pin,
      birthDate: showFallbackDatePicker ? new _moment.default(values.birthDate, "DD/MM/YYYY", true).format("YYYY-MM-DD") : values.birthDate,
      termsConditionsAccepted: values.agreedTerms,
      email_notifications_accepted: values.emailNotificationsAccepted,
      contactPermissions: {
        emailNotificationsAccepted: values.emailNotificationsAccepted,
        inAppNotificationsAccepted: values.inAppNotificationsAccepted,
        smsNotificationsAccepted: values.smsNotificationsAccepted
      }
    };

    if (!isNonUk) {
      params.address = {
        line1: values.street1,
        line2: values.street2,
        city: values.city,
        county: values.county,
        postcode: values.postcode
      };
    } else {
      params.location = location;
    }

    _axios.default.post(isNonUk ? "/auth/register-non-uk" : "/auth/register", params).then(function (_ref4) {
      var data = _ref4.data;
      var access_token = data.access_token,
          refresh_token = data.refresh_token;
      localStorage.setItem("fiver_react_access_token", access_token);
      localStorage.setItem("fiver_react_refresh_token", refresh_token);
      _axios.default.defaults.headers.common["Authorization"] = "Bearer ".concat(access_token);
      setSubmitting(false);
      window.xtremepush("tag", "Registration.AccountCreated", JSON.stringify({
        AppName: process.env.REACT_APP_TITLE
      }));
      onSuccess();

      _axios.default.post("/verification/mobile/send").then(function (_ref5) {
        var data = _ref5.data;

        _reactToastify.toast.success(translations.confirmPhoneCodeSent);
      }).catch(function (_ref6) {
        var error = _ref6.error;
        onError(error);
      });
    }).catch(function (_ref7) {
      var response = _ref7.response;
      var message = translations.signUpError;

      if (response.data) {
        if (response.data.errors) {
          if (response.data.errors.email) {
            message = response.data.errors.email[0];
          }

          if (response.data.errors.username) {
            message = response.data.errors.username[0];
          }
        } else if (response.data.message) {
          message = response.data.message;
        }
      }

      setSubmitting(false);
      setState(_objectSpread(_objectSpread({}, state), {}, {
        signupError: message
      }));
    });
  };

  return /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: initialValues,
    validationSchema: (0, _schema.SignupSchema)(translations, isNonUk, showFallbackDatePicker),
    onSubmit: onSubmit,
    enableReinitialize: true
  }, function (_ref8) {
    var isValid = _ref8.isValid,
        values = _ref8.values,
        errors = _ref8.errors,
        touched = _ref8.touched,
        dirty = _ref8.dirty,
        handleChange = _ref8.handleChange,
        handleBlur = _ref8.handleBlur,
        handleSubmit = _ref8.handleSubmit,
        isSubmitting = _ref8.isSubmitting,
        setFieldValue = _ref8.setFieldValue,
        setFieldError = _ref8.setFieldError,
        setFieldTouched = _ref8.setFieldTouched,
        setTouched = _ref8.setTouched,
        validateField = _ref8.validateField,
        setValues = _ref8.setValues,
        isValidating = _ref8.isValidating;
    var isStep1Valid = !errors.email && !errors.emailConfirm && !errors.birthDate && !errors.firstName && !errors.lastName && !errors.birthDate && !errors.username;
    var isStep2Valid = !errors.mobileNumber && !errors.mobileNumberConfirm && (!errors.city || isNonUk) && (!errors.street1 || isNonUk);
    var isStep3Valid = !errors.password && !errors.passwordConfirm && !errors.pin && !errors.pinConfirm;
    var isStep4Valid = !errors.agreedTerms && !errors.agreedPrivacy;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.PageHeader, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Stepper, {
      onStepClicked: setActiveStep,
      activeStep: activeStep,
      steps: [{
        isValid: true
      }, {
        isValid: dirty && isStep1Valid
      }, {
        isValid: dirty && isStep1Valid && isStep2Valid
      }, {
        isValid: dirty && isStep1Valid && isStep2Valid && isStep3Valid
      }]
    })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Card, null, /*#__PURE__*/_react.default.createElement(_formik.Form, null, /*#__PURE__*/_react.default.createElement(StyledWrapper, null, activeStep === 0 && /*#__PURE__*/_react.default.createElement(_SignupStep.default, {
      showFallbackDatePicker: showFallbackDatePicker,
      translations: translations,
      onStepClicked: setActiveStep,
      isStepValid: isStep1Valid,
      dirty: dirty,
      values: values,
      errors: errors,
      handleChange: handleChange,
      handleBlur: handleBlur,
      setFieldError: setFieldError,
      setFieldTouched: setFieldTouched,
      setTouched: setTouched,
      colorPrimary: colorPrimary,
      touched: touched
    }), activeStep === 1 && /*#__PURE__*/_react.default.createElement(_SignupStep2.default, {
      translations: translations,
      onStepClicked: setActiveStep,
      isStepValid: isStep2Valid,
      setFieldValue: setFieldValue,
      dirty: dirty,
      values: values,
      errors: errors,
      handleChange: handleChange,
      handleBlur: handleBlur,
      dialingCode: dialingCode,
      isNonUk: isNonUk,
      setFieldTouched: setFieldTouched,
      colorPrimary: colorPrimary,
      touched: touched
    }), activeStep === 2 && /*#__PURE__*/_react.default.createElement(_SignupStep3.default, {
      translations: translations,
      onStepClicked: setActiveStep,
      isStepValid: isStep3Valid,
      dirty: dirty,
      values: values,
      errors: errors,
      handleChange: handleChange,
      handleBlur: handleBlur,
      touched: touched
    }), activeStep === 3 && /*#__PURE__*/_react.default.createElement(_SignupStep4.default, {
      useAssetsCdn: useAssetsCdn,
      translations: translations,
      isSubmitting: isSubmitting,
      onPageButtonClicked: onPageButtonClicked,
      onStepClicked: setActiveStep,
      setValues: setValues,
      isStepValid: isStep4Valid,
      dirty: dirty,
      values: values,
      errors: errors,
      signupError: signupError,
      handleChange: handleChange,
      termsSlug: termsSlug,
      privacySlug: privacySlug
    }), activeStep === 4 && /*#__PURE__*/_react.default.createElement(_ConfirmStep.default, {
      translations: translations,
      isSubmitting: isSubmitting,
      onStepClicked: setActiveStep,
      isStepValid: isStep4Valid,
      dirty: dirty,
      values: values,
      isNonUk: isNonUk,
      signupError: signupError
    })))));
  });
};

var _default = Signup;
exports.default = _default;